var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgModeChange = function SvgModeChange(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "mode_change_svg__st0",
    d: "M5.9 6.8H2.4c-.4 0-.9-.3-.9-.9V2.4c0-.5.4-.9.9-.9h3.5c.5 0 .9.4.9.9v3.5c0 .5-.4.9-.9.9zM21.6 6.8H9.8c-.5 0-.9-.3-.9-.9V2.4c0-.5.3-.9.9-.9h11.8c.5 0 .9.4.9.9v3.5c0 .5-.4.9-.9.9zM5.9 22.5H2.4c-.5 0-.9-.4-.9-.9v-3.5c0-.5.4-.9.9-.9h3.5c.5 0 .9.4.9.9v3.5c0 .5-.4.9-.9.9zM21.6 22.5H9.8c-.5 0-.9-.4-.9-.9v-3.5c0-.5.3-.9.9-.9h11.8c.5 0 .9.4.9.9v3.5c0 .5-.4.9-.9.9zM5.9 14.6H2.4c-.5 0-.9-.3-.9-.9v-3.5c0-.5.4-.9.9-.9h3.5c.5 0 .9.3.9.9v3.5c0 .6-.4.9-.9.9zM21.6 14.6H9.8c-.5 0-.9-.3-.9-.9v-3.5c0-.5.3-.9.9-.9h11.8c.5 0 .9.3.9.9v3.5c0 .6-.4.9-.9.9z"
  })));
};
export default SvgModeChange;